import FollowButton from "@/components/FollowButton";
import useAppStore from "@/context/store";
import useRequest from "@/utils/useReq";
import classNames from "classnames";
import dayjs from "dayjs";
import Link from "next/link";
import React, { useCallback, useMemo, useState } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
import { SEX_MAP } from "../../constants/sex";
import { followUser, unfollowUser } from "../../services";
import displayNum from "../../utils/displayNum";
import getTimeDuration from "../../utils/getTimeDuration";
import imageUrl from "../../utils/imageUrl";
import HBAvatar from "../Avatar";
import HBIcon from "../HBIcon";
import Image from "../Image";
import { useJobName } from "../JobSelect/useCrowdTag";
import { useLogin } from "../LoginModal";
import { MuseTag } from "../Muse";
import styles from "./index.module.less";
const infoArr = [
  { label: "画板", key: "board_count" },
  { label: "采集", key: "pin_count" },
  { label: "粉丝", key: "follower_count" },
];
function UserCard({
  className,
  record,
  style,
  hideButton,
  hideTime,
  onFollow,
  grayFollow = false,
}) {
  const user = useAppStore((s) => s.user);
  const { login } = useLogin();
  const { config } = useAppStore(({ config }) => ({ config }));
  const [following, setFollowing] = useState(record?.following);
  const { runAsync: runFollow } = useRequest(followUser, {
    manual: true,
  });
  const { runAsync: runUnfollow } = useRequest(unfollowUser, {
    manual: true,
  });

  const onToggleFollow = useCallback(
    async (e) => {
      // e.stopPropagation();
      e.preventDefault();
      if (!user) {
        const result = await login({
          source_location: "用户关注",
        });
        if (!result) {
          return;
        }
      }

      if (following) {
        const result = await runUnfollow(record?.urlname);
        if (!result.err) {
          record.following = false;
          setFollowing(false);
          onFollow &&
            onFollow(false, {
              ...record,
              following: false,
            });
        }
      } else {
        const result = await runFollow(record?.urlname);
        if (!result.err) {
          record.following = true;
          setFollowing(true);
          onFollow &&
            onFollow(true, {
              ...record,
              following: true,
            });
        }
      }
    },
    [following, login, record, runFollow, runUnfollow, onFollow, user]
  );

  const time = useMemo(() => {
    const createTime = record?.pins?.[0]?.created_at;
    if (createTime) {
      let diffMonth = dayjs(dayjs().format("YYYY-MM-DD")).diff(
        createTime * 1000,
        "month",
        true
      );
      // 超过三个月的不展示
      if (diffMonth.toFixed() > 3) {
        return false;
      }
      return getTimeDuration({ time: createTime * 1000 });
    }
    return false;
  }, [record]);

  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(record?.urlname);
  }, [record, config]);

  const jobName = useJobName(record);

  return (
    <div
      className={classNames([styles.card, className])}
      style={style}
      data-dist-code={record?.custom_recommend ? "人工" : "算法"}
    >
      <Link
        href={`/user/${record?.urlname}`}
        className={styles.inner}
        target="_blank"
        data-gd-expose="people_expose"
        data-gd-click="people_click"
        data-people-id={record?.user_id}
      >
        <div className={styles.imgContent}>
          {[0, 1].map((item) => {
            return (
              <div className={styles.img} key={item}>
                <When condition={!!record.pins?.[item]?.file}>
                  <Image
                    src={imageUrl(record.pins?.[item]?.file, {
                      width: 119,
                      rect: "sq",
                    })}
                    loading="lazy"
                    alt={"采集图片"}
                    showError={true}
                  />
                </When>
              </div>
            );
          })}

          <div className={styles.avatar}>
            <HBAvatar user={record} size={74} srcSize={180} shape="circle" />
          </div>
          {!hideTime && (
            <When condition={time}>
              <div className={styles.action}>
                <div className={styles.dot}></div>
                <span>{time}更新</span>
              </div>
            </When>
          )}
          {/* 推荐理由 */}
          <When condition={hideTime && record.rec_reason}>
            <div className={styles.reason}>
              <HBIcon type={"ic_hot"} />
              {record.rec_reason}
            </div>
          </When>
        </div>
        <div className={styles.title}>
          <span className={styles.text}>{record?.username}</span>
          <Switch>
            <Case condition={isOfficial}>
              <span className={styles.official} title="花瓣官方"></span>
            </Case>
            <Case condition={record?.extra?.is_museuser}>
              <MuseTag user={record} />
            </Case>
          </Switch>
        </div>
        {/* <div className={styles.num}>
          {displayNum(record?.pin_count)}采集 ·{" "}
          {displayNum(record?.follower_count)}
          粉丝
        </div> */}
        <div className={styles.more}>
          <When condition={jobName}>
            <div
              className={classNames([styles.item, styles.oneline])}
              title={jobName}
            >
              {jobName}
            </div>
          </When>
          <If condition={record?.extra?.pro || record?.profile?.data?.location}>
            <Then>
              <When condition={record?.profile?.data?.location}>
                <div
                  className={classNames([styles.item, styles.oneline])}
                  title={record?.profile?.data?.location}
                >
                  {record?.profile?.data?.location}
                </div>
              </When>
            </Then>
            <Else>
              <div className={styles.item}>
                {SEX_MAP[record?.profile?.data?.sex] || "保密"}
              </div>
            </Else>
          </If>
        </div>
        <div className={styles.infoWrapper}>
          {infoArr.map((item) => {
            return (
              <div key={item.key} className={styles.infoItem}>
                <div className={styles.num}>
                  {displayNum(record?.[item.key]) || 0}
                </div>
                <div className={styles.label}>{item.label}</div>
              </div>
            );
          })}
        </div>
        {/* {!hideTime && (
          <If condition={time}>
            <Then>
              <div className={styles.action}>{time} 新增了采集</div>
            </Then>
            <Else>
              <div className={styles.action}></div>
            </Else>
          </If>
        )} */}
      </Link>
      {!hideButton && (
        <If condition={user?.user_id !== record?.user_id}>
          <Then>
            <FollowButton
              followed={following}
              userInfo={record}
              onClick={onToggleFollow}
              showGrop
              data-gd-click="button_click"
              data-button-name={following ? "取消关注" : "关注"}
              data-concern-object-type="用户"
              data-concern-object-name={record?.username}
              grayFollow={grayFollow}
            />
          </Then>
          <Else>
            <div className={styles.placeholder}></div>
          </Else>
        </If>
      )}
    </div>
  );
}

export default React.memo(UserCard);
